import { render, staticRenderFns } from "./ApiService.vue?vue&type=template&id=07b4261e&scoped=true"
import script from "./ApiService.vue?vue&type=script&lang=js"
export * from "./ApiService.vue?vue&type=script&lang=js"
import style0 from "./ApiService.vue?vue&type=style&index=0&id=07b4261e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b4261e",
  null
  
)

export default component.exports